/** @jsxImportSource @emotion/react */

import React from 'react'
import MuiTextField, { TextFieldProps } from '@mui/material/TextField'
import { NumericFormat } from 'react-number-format'

import { grey } from '@mui/material/colors'

type PropsType = TextFieldProps & {
	className?: string
}

export const RenderCurrencyFormatTextField = (props: any) => {
	const { inputRef, onChange, ...other } = props

	return (
		<NumericFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={values => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				})
			}}
			thousandSeparator
			// isNumericString
		/>
	)
}

export const TextField = (props: PropsType) => {
	const isReadOnly: boolean = props.InputProps?.readOnly ?? false

	return (
		<MuiTextField
			{...props}
			css={{
				width: '100%',
				'& fieldset': { borderColor: grey[300] },

				'&.readOnly': {
					label: {
						color: grey[400],
					},

					'.MuiInput-root::before': {
						borderColor: grey[300],
					},

					'.MuiInput-root::after': {
						borderColor: grey[300],
					},

					'.MuiInput-input': {
						color: grey[500],
					},
				},
			}}
			className={`${props.className ?? ''} ${isReadOnly ? 'readOnly' : ''}`}
		/>
	)
}
